import { atom, useAtom } from 'jotai';
import { useUpdateOnboardingFields } from '@teetsh/app/src/queries/user/useUpdateOnboardingFields';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import _get from 'lodash-es/get';
import { useIsBelowBreakpoint } from '@teetsh/app/src/components/ResponsiveSwitcher/useIsBelowSize';

const isSidebarOpenAtom = atom<boolean>(true);

export default function useOnboardingEDTStatus() {
  const updateOnboardingFields = useUpdateOnboardingFields();
  const isMobile = useIsBelowBreakpoint('md');
  const user = useUser();
  const [isOpen, setIsOpen] = useAtom(isSidebarOpenAtom);
  return {
    isOpen: !_get(user, 'onboarding.edt') && isOpen && !isMobile,
    disableOnboarding: async () => {
      await updateOnboardingFields.mutateAsync({
        dashboard: true,
        edtList: true,
        edt: true,
      });
      setIsOpen(false);
    },
    onFinish: () => {
      setIsOpen(false);
    },
  };
}
